/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */


import {Component, OnInit, ViewChild} from '@angular/core';

import {TimeAndAttendanceComponent} from '../../+payrolls/prepare/time/time-and-attendance.component';
import {Contract, Employee} from '../../shared/employees/employees.model';
import {ESSService} from '../employee-self.service';

@Component({
  selector: 'ess-leave-request',
  templateUrl: './leave-request.component.html',
  styleUrls: ['./leave-request.component.css']
})
export class LeaveRequestComponent implements OnInit {

  public static ACCESS_NAME: string = 'ESSLeaveRequest';

  @ViewChild(TimeAndAttendanceComponent)
  public timeComponent: TimeAndAttendanceComponent;

  public employee: Employee;
  public contract: Contract;

  constructor(private essService: ESSService) {
  }

  public ngOnInit() {
    this.essService.currentContract
      .subscribe((contract: Contract) => {
        this.employee = this.essService.employee;
        this.contract = contract;
      });
  }

  public isDirty(): boolean {
    return this.timeComponent && this.timeComponent.isDirty();
  }

  public save() {
    this.timeComponent.saveChanges();
  }

  public cancel() {
    this.contract = Object.assign({}, this.contract);
  }
}
